<template>
  <main>
    <section
      id="intro"
      class="main-row"
    >
      <b-container class="intro-row">
		  <div class="title">
            <h1 v-html="$t('meta.title')"></h1>
            <h2 v-html="$t('meta.lead')"></h2>
		  </div>
        <b-row
          id="learn-more"
          aria-hidden="true"
          align-h="center"
          class="d-none d-sm-flex"
        >
          <input
            id="btn-learn-more"
            type="checkbox"
            class="sr-only"
            @change="$refs['toc_wrapper']
              .scrollIntoView({ behavior: 'smooth' })"
          />
          <label
            for="btn-learn-more"
            class="btn btn-sm btn-link p-0"
          >
            <span>En savoir plus</span>
            <i class="fas fa-lg fa-chevron-down d-block fc-g8"></i>
          </label>
        </b-row>
      </b-container>
    </section>

    <div id="nav-sticky" class="position-sticky sticky-top px-0 d-flex d-lg-none justify-content-center flex-grow-1">
      <b-nav pills class="nav-wrapper mx-0 nav-expand">
        <b-nav-item href="#understand">Comprendre</b-nav-item>
        <b-nav-item href="#risks_first">Impacts</b-nav-item>
        <b-nav-item href="#risks_second">Risques</b-nav-item>
        <b-nav-item href="#except">Société</b-nav-item>
      </b-nav>
    </div>

    <div id="toc_wrapper" ref="toc_wrapper">
      <div>
        <Preamble />
        <understand />
        <News :tags="$t('news.blocks.definition.tags')" :title="$t('news.blocks.definition.title')" />
        <risks />
        <News :tags="$t('news.blocks.impacts.tags')" :title="$t('news.blocks.impacts.title')" />
        <risks2 />
        <News :tags="$t('news.blocks.risks.tags')" :title="$t('news.blocks.risks.title')" />
        <except />
      </div>
      <div id="toc_container" class="no_bullets">
        <ol class="toc_list">
          <li><a href="#preamble" v-html="$t('preamble.title')"></a></li>
          <li>
            <a href="#understand" v-html="$t('understand.title')"></a>
            <ol>
              <li><a href="#understand_what" v-html="$t('understand.chapters.what.title')"/></li>
              <li><a href="#understand_how" v-html="$t('understand.chapters.how.title')"/></li>
              <li><a href="#understand_multiple" v-html="$t('understand.chapters.multiple.title')"/></li>
              <li><a href="#understand_families" v-html="$t('understand.chapters.families.title')"/></li>
            </ol>
          </li>
          <li>
            <a href="#risks_first" v-html="$t('risks_first.title')"/>
            <ol>
              <li><a href="#risks_first_economy" v-html="$t('risks_first.chapters.economy.title')"/></li>
              <li><a href="#risks_first_extractivism" v-html="$t('risks_first.chapters.extractivism.title')"/></li>
              <li><a href="#risks_first_ecocidal" v-html="$t('risks_first.chapters.ecocidal.title')"/></li>
            </ol>
          </li>
          <li>
            <a href="#risks_second" v-html="$t('risks_second.title')"/>
            <ol>
              <li><a href="#risks_second_work" v-html="$t('risks_second.chapters.work.title')"/></li>
              <li><a href="#risks_second_culture" v-html="$t('risks_second.chapters.culture.title')"/></li>
              <li><a href="#risks_second_political" v-html="$t('risks_second.chapters.political.title')"/></li>
            </ol>
          </li>
          <li>
            <a href="#except" v-html="$t('except.title')"/>
            <ol>
              <li><a href="#except_ethics" v-html="$t('except.chapters.ethics.title')"/></li>
              <li><a href="#except_question" v-html="$t('except.chapters.question.title')"/></li>
              <li><a href="#except_lokas" v-html="$t('except.chapters.lokas.title')"/></li>
            </ol>
          </li>
        </ol>
        <img loading="lazy" :src="`${$t('baseurl')}img/lokas-2.png`" alt="" width="200" />
      </div>
    </div>

    <div class="d-flex d-lg-none align-items-center justify-content-center mb-5">
      <img loading="lazy" :src="`${$t('baseurl')}img/lokas-2.png`" alt="" width="200" />
    </div>

    <who />

    <div class="d-flex align-items-center justify-content-center">
      <img loading="lazy" :src="`${$t('baseurl')}img/lokas-1.png`" alt="" width="200" />
    </div>

    <sfs />

    <outro />
  </main>
</template>

<script>
import Preamble from '../components/Preamble.vue';
import Understand from '../components/Understand.vue';
import Risks from '../components/Risks.vue';
import Risks2 from '../components/Risks2.vue';
import Except from '../components/Except.vue';
import Who from '../../commons/components/hos/Who.vue';
import Outro from '../../commons/components/hos/Outro.vue';
import Sfs from '../../commons/components/sfs/Main.vue';
import News from '../components/News.vue';

export default {
  components: {
    Preamble,
    Understand,
    Risks,
    Risks2,
    Except,
    Who,
    Outro,
    Sfs,
    News
  },

  data() {
    return {
      observer: null,
    }
  },

  created() {
    this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute('data-section') || entry.target.getAttribute('data-chapter');
          if (entry.intersectionRatio > 0) {
            document.querySelector(`#toc_container li a[href="#${id}"]`)?.parentElement?.classList?.add('active');
            const child = document.querySelector(`#nav-sticky .nav .nav-link[href="#${id}"]`);
            if (child) {
              child.parentElement.classList?.add('active');
              this.scrollIntoViewHorizontally(document.querySelector('#nav-sticky .nav'), child);
            }
          } else {
            document.querySelector(`#toc_container li a[href="#${id}"]`)?.parentElement?.classList?.remove('active');
            const child = document.querySelector(`#nav-sticky .nav .nav-link[href="#${id}"]`);
            if (child) {
              child.parentElement.classList?.remove('active');
            }
          }
        });
      }, {
        root: this.$el,
      });
  },
  mounted() {
    // Track all sections that have an `id` applied
    document.querySelectorAll('section[data-section], div[data-chapter]').forEach((section) => {
      this.observer.observe(section);
    });
  },
  methods: {
    scrollIntoViewHorizontally(container,child) {
      const child_offsetRight = child.offsetLeft + child.offsetWidth;
      const container_scrollRight = container.scrollLeft + container.offsetWidth;

      if (container.scrollLeft > child.offsetLeft) {
        container.scrollLeft = child.offsetLeft;
      } else if (container_scrollRight < child_offsetRight) {
        container.scrollLeft += child_offsetRight - container_scrollRight;
      }
    }
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>

<style lang="scss">
#home {
	background-color: #ffffff;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='450' height='450'%3E%3Cpath fill='%23141414' fill-opacity='0.025' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E");
  position: relative;
  background-attachment: fixed;
  
}

section#intro {
  filter: drop-shadow(2px 5px 4px rgba(0, 0, 0, .2));
  padding: 1rem 0 3rem;
  position: relative;

  @media (max-width: 480px) {
    max-height: 600px;
  }

  &::before, &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before {
    background: var(--f-f7);
    -webkit-clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);
    clip-path: polygon(0 0, 0 100%, 100% 83%,  100% 0);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
      clip-path: polygon(0 0, 0 100%, 100% 93%,  100% 0);
    }
  }

  &::after {
    background: var(--f-g5);
    background-image: url(../../public/img/opengraph/home-750w.jpg);
    @media (max-width: 800px) {
      background-image: image-set(url(../../public/img/opengraph/home-750w.jpg) 1x, url(../../public/img/opengraph/home.jpg) 2x);
    }
    @media (min-width: 800px) {
      background-image: image-set(url(../../public/img/opengraph/home.jpg) 1x, url(../../public/img/opengraph/home-2000w.jpg) 2x);
    }
    @media (min-width: 1500px) {
      background-image: url(../../public/img/opengraph/home-2000w.jpg);
    }
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-clip-path: polygon(0 0,100% 0,100% 100%,0 88%);
    clip-path: polygon(0 0,100% 0,100% 100%,0 88%);

    @media (max-width: 768px) {
      -webkit-clip-path: polygon(0 0,100% 0,100% 98%,0 95%);
      clip-path: polygon(0 0,100% 0,100% 98% ,0 95%);
    }
  }

  .container {
    position: relative;
    z-index: 1;
  }

  .intro-row {
    padding-bottom: 5rem;
    @media (max-width: 1001px) {
		padding-bottom: 3rem;
		min-height: 30rem;
    }

    @media (min-width: 1000px) {
		padding-bottom: 10rem;
		min-height: 35rem;
    }

    @media (min-width: 1440px) {
		padding-bottom: 15rem;
		min-height: 45rem;
    }

    @media (min-width: 1800px) {
      padding-bottom: 20rem;
    }

    @media (min-width: 2000px) {
      padding-bottom: 25rem;
      margin-top: 9rem;
    }

  }
  
  .title {
	background: rgba(221,100,24,.8);
	font-family: Tovari Sans;
	font-weight: 700;
	text-transform: uppercase;
	font-weight: 300;
	font-size: 2rem;
	margin: 1rem 0 1rem;
	padding: 1rem 5rem;
	border-radius: .5rem;
	line-height: 1;
	position: absolute;
    @media (min-width: 1440px) {
	top: 25rem;
	left: -15vw;
	}
    @media (max-width: 1439px) {
	top: 1rem;
	left: 1rem;
	}
    @media (max-width: 992px) {
	top: 0;
	left: 1rem;
	margin-right: 1rem;
	padding: 1rem 2rem;
	}
  }

  h1{
    color: var(--f-d1);
    font-size: 5rem;
    font-weight: 300;
    //margin: 4rem 0 3rem;

    @media (max-width: 1220px) {
      font-size: 2.5rem;
      //margin: 3rem 0 2rem;
    }

    @media (max-width: 768px) {
      font-size: 2.5rem;
      //margin: 2rem 0 1.5rem;
    }
  }

  h2 {
    color: var(--f-d1);
	font-size: 2.5rem;
    font-weight: 300;
    line-height: 1.25;
    margin: 0;

    @media (max-width: 992px) {
      font-size: 1.75rem;
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    color: var(--f-d1);
  }

  .actions {
    display: inline-flex;
    align-items: flex-start;
    margin: 4rem auto 5.5rem;

    @media (max-width: 768px) {
      margin: 3rem auto 1.5rem;
      flex-direction: column;
    }

    .btn {
      width: 13rem;
      margin: .25rem .75rem;
      padding: .75rem 1.25rem;
      text-transform: uppercase;

      @media (max-width: 992px) {
        padding: .5rem 1rem;
        width: 12rem;
      }

      @media (max-width: 768px) {
        margin: .125rem 0;
      }

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .btn-outline-light {
    @media (min-width: 768px) {
      border: transparent;
    }
  }

  #learn-more {
	position: absolute;
	bottom: 5px;
    left: 45%;
  
    label {
      color: var(--f-d1);
      background: none;
      text-decoration: none;

      i::before {
        color: var(--f-d1);
      }
    }

    span {
      padding: .25rem ;
      font-size: .875rem;
    }

    input:checked ~ label {
      visibility: hidden;
    }
  }
}

#what {
  padding: 4rem 0;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 2rem;

    @media (min-width: 768px) {
      font-size: 3rem;
      line-height: 4rem;
    }
  }

  .card-header {
    border: none;
    background: transparent;
    padding: 0;

    .nav li {
      background: var(--f-g1);
      padding: 0.75rem 1.25rem;
    }
  }

  .card-body .row {
    align-items: center
  }

  h3 {
    font-size: 2rem;
    @media (min-width: 768px) {
      font-size: 3rem;
    }
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 1;
    margin: .5rem 0 1rem;

    @media (max-width: 992px) {
      font-size: 2rem;
    }

    @media (max-width: 768px) {
      font-size: 1.75rem;
    }
  }

  p {
    font-size: 1.35rem;
    font-weight: 200;
    line-height: 1.4;

    @media (max-width: 992px) {
      font-size: 1rem;
    }
  }
}

/* SFS */
#support {
  @media (min-width: 992px) { /* cat is hidden by the form below 992px */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 40px);
  }

  .col-lg-7 .ombre {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  #f-sfs + div { /* #outro parent */
    background:
      transparent
      url('../../public/img/gattino-galileo.png')
      no-repeat
      10% calc(100% + 20px);
  }
}

html, #f-- {
  font-size: 18px !important;
}

main {
  h2:not(section#intro h2) {
    background: var(--f-o6);
    border-radius: .5rem;
    color: #fff;
    font-family: Tovari Sans,sans-serif;
    font-size: 2rem;
    @media (min-width: 768px) {
      font-size: 3rem;
    }
    font-style: normal;
    line-height: 2.5rem;
    padding: 1.25rem 1.75rem .5rem;
    text-align: center;
    text-transform: uppercase;
    transform: rotate(-2deg);
    width: fit-content;
    margin-bottom: 1em;
    max-width: 90vw;
    word-break: break-word;
  }

  section {
    h4 {
      color: var(--f-g10);
      font-family: Tovari Sans,sans-serif;
      font-size: 2rem;
      padding: 0;
    }
    blockquote {
      background: color-mix(in srgb, transparent, black 5%);
    }
  }

  figcaption {
    max-width: 600px;
  }
}

#nav-sticky {
  z-index: 5;
  top: 0;
  background: none repeat scroll 0 0 #fff;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;

  .nav-wrapper {
    position: relative;
    overflow: hidden;
    padding: 5px 5px 5px 7.5px;
    height: 50px;
    margin: 0 15px;

    li {
      text-transform: uppercase;
      white-space: nowrap;

      .nav-link {
        padding: 0.5rem 0.5rem;
        font-size: 0.85rem;
      }

      &.active {
        background: var(--f-g3);
        border-radius: 0.5rem;
      }
    }

    &.nav-expand {
      flex-flow: row nowrap;
      justify-content: flex-start;
    }
  }
}

#toc_wrapper {
  display: grid;
  @media (min-width: 992px) {
    grid-template-columns: minmax(auto, 3fr) minmax(300px, 1fr);
  }
  max-width: 100rem;
  margin: 0 auto;
}

#toc_container {
  @media (max-width: 992px) {
    display: none;
  }

  position: sticky;
  top: 2rem;
  align-self: start;
  padding: 1rem;
  background-color: #fdfdfd;
  border-left: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  border-radius: 0 0 0 10px;

  > img {
    margin: 2rem 0 4rem 2rem;
  }

  ol.toc_list, ol {
    list-style: none;
    margin: 0;
    padding: 0;
	max-height: 90vh;
	overflow-y: auto;
	overscroll-behavior: contain;

    li {
      margin-left: 1rem;

      &.active > a {
        color: var(--f-g8);
        font-weight: 500;
      }
    }

    a {
      background: none;
      text-decoration: none;
      display: block;
      padding: .125rem 0;
      color: var(--f-g6);
      font-size: 1rem;
      transition: all 50ms ease-in-out; /* 💡 This small transition makes setting of the active state smooth */

      &:hover, &:focus {
        color: var(--f-g7);
      }
    }
  }
}

/* Framanav */
#home #fp-alert {
  background: var(--f-d1);
}

.f-bs4 #f-footer {
  border: none !important;
}
</style>
